import { Building } from "lucide-react";
import type { WorkerSalon } from "@/gql/graphql";
import type { Salon } from "@/lib/store/salon";

interface SalonInfoCardProps {
  salon: Salon;
  userSalonRoles?: WorkerSalon[];
}

export function SalonInfoCard({ salon, userSalonRoles }: SalonInfoCardProps) {
  const _currentUserRole = userSalonRoles?.find((role) => role.salonId === salon.id);

  return (
    <div className="rounded-lg">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-lg bg-indigo-100 dark:bg-indigo-800/30 flex items-center justify-center">
            <Building className="w-6 h-6 text-indigo-600 dark:text-indigo-400" />
          </div>
        </div>
        <div className="flex-1 min-w-0 text-left">
          <div className="font-medium text-foreground truncate">{salon.name}</div>
          <div className="text-sm text-muted-foreground break-words">{salon.address}</div>
          {salon.city && salon.state && (
            <div className="text-xs text-muted-foreground mt-1 break-words">
              {salon.city}, {salon.state}
            </div>
          )}
          <div className="flex items-center gap-2 mt-2">
            {salon.timezone && (
              <div className="text-xs text-muted-foreground truncate">🌍 {salon.timezone}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
